/*
 * BioIndex
 * Copyright (c) 2026 BioIndex™. All rights reserved.
 * Unauthorized copying, scraping, redistribution, or commercial reuse is prohibited.
 */

import { generaByFamily, familiesByOrder, ordersByClass, classesByPhylum, phylaByKingdom } from "./taxonomy";

const simplify = (value) => String(value || "").trim().toLowerCase().replace(/\s+/g, " ");

function findParent(groups, child) {
  const wanted = simplify(child);
  for (const [parent, children] of Object.entries(groups)) {
    if ((children || []).some((name) => simplify(name) === wanted)) return parent;
  }
  return null;
}

/** Returns null for taxa without a complete published hierarchy. */
export function taxonomicSpeciesRoute(acceptedScientificName, profileUID = "") {
  const name = String(acceptedScientificName || "").trim().replace(/\s+/g, " ");
  const genus = name.split(" ")[0];
  if (!genus || name.split(" ").length < 2) return null;
  const family = findParent(generaByFamily, genus);
  const order = family && findParent(familiesByOrder, family);
  const className = order && findParent(ordersByClass, order);
  const phylum = className && findParent(classesByPhylum, className);
  const kingdom = phylum && findParent(phylaByKingdom, phylum);
  if (!kingdom) return null;
  const pathParts = ["kingdom", kingdom, "phylum", phylum, "class", className,
    "order", order, "family", family, "genus", genus];
  const path = pathParts.map((part) => encodeURIComponent(simplify(part))).join("/");
  const base = profileUID ? `/explore/${encodeURIComponent(profileUID)}` : "";
  return `${base}/${path}?species=${encodeURIComponent(name)}`;
}
